<template>
  <div class="hero currentBackground">
    <!-- diagonal overlay -->
    <div class="text-block">
      <h1 class="hero-title">Santiago Ramirez's Portfolio</h1>
      <h2 class="hero-subtitle">Software Engineer | Python, DevOps, and More</h2>
      <button
        @click="scrollToProfile"
        class="hero-btn"
      >
        View My Work
      </button>
    </div>

    <nav class="social-links">
      <li class="social-links__list">
        <a class="social-links__link" rel="noopener noreferrer" target="_blank" title="Visit my GitHub profile" :href="links.github">
          <img class="social-icon" src="@/assets/icons/github.svg" alt="GitHub Icon">
        </a>
      </li>
      <li class="social-links__list">
        <a class="social-links__link" rel="noopener noreferrer" target="_blank" title="View my projects on GitLab" :href="links.gitlab">
          <img class="social-icon" src="@/assets/icons/gitlab-logo-500.svg" alt="GitLab Logo">
        </a>
      </li>
      <li class="social-links__list">
        <a class="social-links__link" rel="noopener noreferrer" target="_blank" title="Connect with me on LinkedIn" :href="links.linkedin">
          <img class="social-icon" src="@/assets/icons/linkedin2.svg" alt="LinkedIn Icon">
        </a>
      </li>
      <li class="social-links__list">
        <a class="social-links__link" rel="noopener noreferrer" target="_blank" title="Email me" :href="'mailto:'+links.mail">
          <img class="social-icon" src="@/assets/icons/mail.svg" alt="Email Icon">
        </a>
      </li>
    </nav>
  </div>
</template>

<script>
export default {
  name: "HomeSection",
  data(){
    return {
      links:{
        'linkedin':'https://www.linkedin.com/in/santosdev',
        'github':'https://github.com/santosdevco/',
        'gitlab':'https://gitlab.com/santiagoAndre/',
        'mail':'projects@santosdevco.com'
      }
    }
  },
  methods: {
    scrollToProfile() {
      // Use the Vue nextTick function to wait for the DOM to update
      this.$nextTick(() => {
        const profileSection = document.getElementById("projects");
        if (profileSection) {
          profileSection.scrollIntoView({ behavior: "smooth" });
        }
      });
    },
  },
  // Other component options
};
</script>

<style scoped>
/* ── Layout ──────────────────────────────────────────────── */
.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* diagonal tint overlay — kept exactly as before */
.currentBackground {
  --main-bg-color: #0f172a;
  background-color: var(--main-bg-color);
}
.currentBackground::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.04);
  clip-path: polygon(80% 0, 0 0, 0 100%, 20% 100%);
  z-index: 0;
}
.hero > * {
  position: relative;
  z-index: 1;
}

/* ── Text block — truly centered ────────────────────────── */
.text-block {
  text-align: center;
  padding: 0 1.5rem;
  max-width: 700px;
}

.hero-title {
  font-size: clamp(2.2rem, 5vw, 4rem);
  font-weight: 800;
  color: #fff;
  margin: 0 0 1rem;
  line-height: 1.15;
}

.hero-subtitle {
  font-size: clamp(1.1rem, 2.5vw, 1.75rem);
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
  margin: 0 0 2rem;
}

.hero-btn {
  color: #0f172a;
  background: #ffffff;
  font-family: inherit;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.6rem 2rem;
  border: none;
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);
  cursor: pointer;
  transition: background 0.2s ease, transform 0.15s ease;
}
.hero-btn:hover {
  background: #e2e8f0;
  transform: translateY(-2px);
}

/* ── Social icons — fixed to right edge on desktop ───────── */
.social-links {
  list-style: none;
  padding: 0;
  margin: 0;
  position: absolute;
  right: 3rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
}

.social-icon {
  width: 2.75rem;
  height: 2.75rem;
  display: block;
}

.social-links__link {
  display: block;
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.social-links__link:hover {
  opacity: 0.75;
  transform: scale(1.12);
}

/* ── Prevent title wrapping on large screens ─────────────── */
@media (min-width: 769px) {
  .hero-title {
    white-space: nowrap;
  }
  .text-block {
    max-width: none;
  }
}

/* ── Mobile — icons go below the button ──────────────────── */
@media (max-width: 768px) {
  .social-links {
    position: static;
    transform: none;
    flex-direction: row;
    margin-top: 2.5rem;
    gap: 1.75rem;
  }
  .social-icon {
    width: 2.25rem;
    height: 2.25rem;
  }
}
</style>
